<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div
				style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				卡密列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;"
						@click="getData">刷新数据</el-button>
				</div>

			</div>
			<div style="padding: 15px;display: flex;align-items: center;" class="search">
				<el-select v-model="form.software" filterable clearable placeholder="请选择所属软件"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(key,value) in software_info" :key="software_info[value].id"
						:label="formatValue(value)" :value="value"
						>
					</el-option>
				</el-select>
				<el-select v-model="form.card_state" clearable placeholder="请选择卡密状态"
					style="width: 150px;margin-right: 10px;" @change="search" size="small" >
					<el-option v-for="(key,value) in card_state_conf" :key="key" :label="card_state_conf[value]"
						:value="value"
						:disabled="form.software===''&&(value==='online'|| value=='downline')">
						 <el-tooltip class="item" effect="dark" content="请先选择所属软件" placement="right" v-if="form.software===''&&(value==='online'|| value=='downline')">
						      <div style="width: 100%;">{{card_state_conf[value]}}</div>
						</el-tooltip>
					</el-option>
				</el-select>
				<el-select v-model="form.card_type" clearable placeholder="请选择类型"
					style="width: 150px;margin-right: 10px;" @change="search" size="small"
					:popper-append-to-body="false"
					 popper-class="eloption">
					<el-option v-for="(key,value) in type_config" :key="type_config[value].id"
						:label="type_config[value].name" :value="type_config[value].id" >
					</el-option>
				</el-select>
				
				
				<el-input type="number" clearable placeholder="代理人ID" v-model="form.agent_id" size="small"
					style="width: 200px;margin-right: 10px;" @clear="getData">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
				<el-input clearable placeholder="卡密/备注" v-model="form.card" size="small"
					style="width: 200px;margin-right: 20px;" @clear="getData">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
				<!-- <el-button type="success" size="small" style="border-radius: 0;" @click="exportData">导出</el-button> -->
				<el-button type="info" size="small" style="border-radius: 0;"
					@click="dialogVisible=true">批量操作</el-button>
				<el-button type="success" size="small" style="border-radius: 0;" @click="exportData">导出</el-button>
				<div style="display: flex; align-items: center;margin-left: auto;">

					<el-button type="success" size="small" style="border-radius: 0;"
						:disabled="multipleSelection.length===0" @click="openRenewalDialog">续期</el-button>
					<el-button type="danger" size="small" style="border-radius: 0;"
						:disabled="multipleSelection.length===0" @click="deleteAll">删除</el-button>
				</div>
			</div>
			<el-table ref="tablelist" :data="list" stripe
				style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
				@selection-change="handleSelectionChange"
				:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
				:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
				v-loading="loading">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="card" align="center" label="卡密" min-width="140">
					<template slot-scope="scope">
						<el-tooltip effect="dark" content="点击复制" placement="right">
							<div style="width: 140px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;cursor: pointer;"
								@click="copy(scope.row.card)">{{scope.row.card}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="类型" min-width="60" align="center">
					<template slot-scope="scope">
						{{type_config[scope.row.type].name}}卡
					</template>
				</el-table-column>
				<el-table-column label="在线状态" min-width="90" align="center">
					<template slot-scope="scope">
						<el-link :underline="false" type="success"
							v-if="is_online(scope.row,software_info,now_timestamp)=='在线'">{{is_online(scope.row,software_info,now_timestamp)}} <span v-if="scope.row.online_num>1">x {{scope.row.online_num}}</span></el-link>
						<el-link :underline="false" type="danger"
							v-else>{{is_online(scope.row,software_info,now_timestamp)}}</el-link>
					</template>
				</el-table-column>
				<el-table-column label="卡密状态" min-width="80" align="center">
					<template slot-scope="scope">
						{{card_state_trans(scope.row,now_timestamp)}}
					</template>
				</el-table-column>
				<el-table-column label="所属软件" min-width="80" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{formatValue(scope.row.software)}}
					</template>
				</el-table-column>
				<el-table-column label="生成时间" min-width="150" align="center">
					<template slot-scope="scope">
						{{scope.row.addtime|formatTime}}
					</template>
				</el-table-column>
				<el-table-column label="最近使用" min-width="140" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{scope.row.usetime|formatTime}}
					</template>
				</el-table-column>
				<el-table-column label="到期时间" min-width="140" align="center">
					<template slot-scope="scope">
						{{scope.row.endtime|formatTime}}
					</template>
				</el-table-column>
				<el-table-column label="激活时间" min-width="140" align="center">
					<template slot-scope="scope">
						{{scope.row.active_time|formatTime}}
					</template>
				</el-table-column>
				<el-table-column label="多端数量" min-width="70" align="center">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;justify-content: center;">
							<span>{{scope.row.max_num}}</span>
						</div>

					</template>
				</el-table-column>
				<el-table-column label="备注" min-width="100" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{scope.row.one}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button type="warning" size="small" @click="toEdit(scope.row.card)">修改</el-button>
						<el-button type="danger" size="small" @click="toDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="footer">
				<el-pagination layout="total, prev, pager, next,sizes" @current-change="toPage"
					@size-change="handleSizeChange" :total="total" :page-sizes="[10, 25, 50, 100]"
					:current-page="form.page" :page-size="form.limit">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="输入卡密,一行一个" :visible.sync="dialogVisible" width="30%">
			<el-input type="textarea" :rows="8" placeholder="请输入卡密" v-model="cards">
			</el-input>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="confromCard" :disabled="!cards">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="信息" :visible.sync="dialogOptions" width="300px">
			<div style="padding: 20px;font-size: 18px;display: flex;align-items: center;justify-content: center;">
				请选择操作类型
			</div>
			<span slot="footer" class="dialog-footer"
				style="display: flex;align-items: center;justify-content: center;">
				<el-button size="small" type="primary" @click="choose_option('search')">查 询</el-button>
				<el-button size="small" type="danger" @click="choose_option('delete')">删 除</el-button>
				<el-button size="small" @click="choose_option('add_time')">续费</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="copyCodeTitle" :visible.sync="dialogCopyCode" width="500px">
			<div style="padding: 10px;font-size: 18px;display: flex;align-items: flex-start;justify-content: center;max-height: 300px;overflow-y: auto;flex-direction: column;margin-bottom: 5px;"
				v-if="not_exist_cards.length>0">
				<div style="color: #000;font-size: 14px;margin-bottom:5px ;" v-for="(item,index) in not_exist_cards"
					:key="index">
					{{item}}
				</div>
			</div>
			<div style="color: #ccc;font-size: 12px;display: flex;align-items: center;justify-content: center;margin-top: 10px;width: 100%;"
				v-if="not_exist_cards.length>0">（点击确定复制后自动复制执行失败卡密）</div>
			<div style="padding: 10;display: flex;align-items: center;justify-content: center;color: #ccc;font-size: 14px;"
				v-if="not_exist_cards.length==0">
				全部处理完毕
			</div>
			<span slot="footer" class="dialog-footer"
				style="display: flex;align-items: center;justify-content: center;">

				<el-button size="small" type="danger" @click="copyValue"
					v-if="not_exist_cards.length>0">确定复制</el-button>
				<el-button size="small" type="primary" @click="dialogCopyCode = false">关闭弹窗</el-button>
			</span>
		</el-dialog>
		<el-dialog title="续期" :visible.sync="renewalDialog" width="460px">

			<el-form label-width="120px">
				<el-form-item label="时间输入方式" prop="name">
					<el-radio-group v-model="renewal_way">
						<el-radio label="input">手动输入</el-radio>
						<el-radio label="select">点击选择</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="续期时间" prop="name" v-if="renewal_way==='select'">
					<Picker :date="renewal" placeholder="请选择续期时间" @confrim="confrimDate"></Picker>
				</el-form-item>
				<el-form-item label="续期时间(天)" prop="name" v-if="renewal_way==='input'">
					<el-input v-model="renewal_day" placeholder="请输入续期时间" size="small" type="number" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="续期类型" prop="name">
					<el-radio-group v-model="renewal_type">
						<el-radio label="add">增加时间</el-radio>
						<el-radio label="sub">减少时间</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>


			<span slot="footer" class="dialog-footer"
				style="display: flex;align-items: center;justify-content: center;margin-top: -20px;">
				<el-button size="small" type="danger" @click="toAddTime()">确定</el-button>
				<el-button size="small" @click="renewalDialog=false">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	function trimAll(ele){
	    if(typeof ele === 'string'){
	       return ele.replace(/[ ]/g, "");
	           
	    }else{
	        console.error(`${typeof ele} is not the expected type, but the string type is expected`)
	    }
	  
	}
	let timer = null
	import {
		saveAs
	} from 'file-saver'
	import axios from 'axios'
	import Picker from '@/components/select/Picker.vue'
	import {
		mapState
	} from 'vuex'
	export default {
		components: {
			Picker
		},
		data() {
			return {
				renewal: 0,
				renewal_type: 'add',
				renewal_way: 'input',
				renewal_day: 0,
				renewalDialog: false,
				dialogCopyCode: false,
				copyCodeTitle: '',
				not_exist_cards: '',
				cards: '',
				loading: false,
				dialogVisible: false,
				dialogOptions: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					card: "",
					card_state: "all",
					card_type: "",
					agent_id: '',
					page: 1,
					software: '',
					limit: 10,
					card_list:''
				},
				type_config: {},
				software_info: {},
				now_timestamp: 0,
				card_state_conf: {},
				list: [],
				multipleSelection: [],
				input_cards: null

			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return '-'
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		beforeDestroy() {
			clearInterval(timer)
		},
		computed: {
			...mapState({
				user: state => state.user,
				reload: state => state.reload
			})
		},
		watch: {
			reload(n, v) {
				this.getData()
			},
			dialogVisible(n, v) {
				if (!n) {
					this.input_cards = null
				}
			},
			renewal_way(n,v){
				if(n==='input'){
					this.renewal_day = (this.renewal/86400).toFixed(2)
				}else{
					this.renewal = parseInt(this.renewal_day*86400)
				}
			},
			cards(n,v){
				console.log(trimAll(n))
				this.cards = trimAll(n)
			}
		},
		created() {
			let searchForm = window.localStorage.getItem('searchForm_' + this.user.center_id)
			if (searchForm) {
				this.form = JSON.parse(searchForm)
			}
			let limit = window.localStorage.getItem('card_limit_' + this.user.center_id)
			if (limit) {
				this.form.limit = parseInt(limit)
			}
			this.form.page = 1
			this.getData()
			this.now_timestamp = window.localStorage.getItem('timestamp_' + this.user.center_id)
		},
		mounted() {

			this.$nextTick(() => {
				if (!this.$refs.tablelist) return;
				this.$refs.tablelist.bodyWrapper.scrollLeft = 0
				let scrollLeft = 1
				let type = 'add'
				timer = setInterval(() => {
					if (type == 'add') {
						scrollLeft = scrollLeft + 20
					} else {
						scrollLeft = scrollLeft - 20
					}

					this.$refs.tablelist.bodyWrapper.scrollLeft = scrollLeft
					if ((scrollLeft - 1) > this.$refs.tablelist.bodyWrapper.scrollLeft) {
						type = "sub"
					}
					if (scrollLeft <= 0) {
						clearInterval(timer)
						this.$refs.tablelist.bodyWrapper.scrollLeft = 0
					}
					this.scrollLeft = this.$refs.tablelist.bodyWrapper.scrollLeft
				}, 30)
			})
		},
		methods: {
			confrimDate(e) {
				this.renewal = e
			},
			openRenewalDialog() {
				this.renewal = 0
				this.renewalDialog = true
			},
			copy(text) {
				this.$copyText(text).then((e) => {
					this.$message.success('复制成功')
					console.log(e)
				}, (e) => {
					console.log(e)
				})
			},
			handleSizeChange(e) {
				this.form.page = 1
				this.form.limit = e
				window.localStorage.setItem('card_limit_' + this.user.center_id, e)
				this.getData()
			},
			exportData() {
				console.log(this.total)
				
				this.$confirm('是否导出' + this.total + '条卡密数据', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let form = {
						token: window.localStorage.getItem('token') || '',
						client_type: 'pc_web',
						client_version: '1.3.5',
						client_platform: 'windows',
						project: 'quanlang',
						...this.form
					}
					console.log(this.changeParam(form))
					
					// saveAs('http://bp.2cccc.cc/verify_center/v1_0_1.Card/export' + this.changeParam(form), this
					// 	.total + '条卡密数据.xls')
					this.loading = true
					axios.post('http://bp.2cccc.cc/verify_center/v1_0_1.Card/export', form,{
						responseType:'blob',
					}).then(res => {
						this.loading = false
						if(res.data){
							console.log(res.data)
							let blob = new Blob([res.data],{
								type:'application/vnd.ms-excel'
							})
							saveAs(blob, this.total + '条卡密数据.xls')
						}

					}).catch(err => {
						this.loading = false
					})
				}).catch(() => {

				});
			},
			changeParam(param) {
				return JSON.stringify(param).replace(/:/g, '=').replace(/,/g, '&').replace(/{/g, '?').replace(/}/g, '')
					.replace(/"/g, '');
			},
			formatValue(key) {
				let item = this.software_info[key]
				if (key === 'all_software') {
					return 'all_software'
				}
				return item.one || key
			},
			choose_option(params) {
				let input_cards = this.cards.split(/[(\r\n)\r\n]+/);
				console.log(input_cards)
				switch (params) {
					case 'delete':
						this.$confirm('是否删除所输入卡密?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$H.post('verify_center/v1_0_1.Card/Option', {
								option: 'input_cards_delete',
								cards: input_cards
							}).then(res => {
								if (!res.data) return;
								this.not_exist_cards = res.data.not_exist_cards
								this.copyCodeTitle = '成功【' + res.data.num + '】个，失败【' + (res.data.count -
									res.data
									.num) + '】个'
								this.dialogCopyCode = true
								this.getData()
								// const h = this.$createElement;
								// let list = []
								// if (res.data.num == res.data.count) {
								// 	list.push(h('p', {
								// 		style: 'display:flex;justify-content: center;'
								// 	}, '全部处理成功'))
								// } else {
								// 	list.push(h('p', {
								// 		style: 'display:flex;justify-content: center;'
								// 	}, '失败的有'))
								// 	for (let i = 0; i < res.data.not_exist_cards.length; i++) {
								// 		list.push(h('p', {
								// 			style: 'display:flex;justify-content: center'
								// 		}, res.data.not_exist_cards[i]))
								// 	}
								// 	list.push(h('p', {
								// 		style: 'display:flex;justify-content: center;'
								// 	}, '(点击确认自动复制)'))
								// }

								// this.$msgbox({
								// 	title: '成功【' + res.data.num + '】个，失败【' + (res.data.count - res.data.num) +
								// 		'】个',
								// 	message: h('p', {
								// 		style: 'color:#ccc;padding:10px'
								// 	}, list),
								// 	showCancelButton: true,
								// 	confirmButtonText: '确定',
								// 	cancelButtonText: '取消',
								// }).then(action => {
								// 	console.log(action)
								// 	if (res.data.num != res.data.count) {
								// 		this.$copyText(res.data.not_exist_cards.join(',')).then((e) => {
								// 			this.$message.success('复制成功')
								// 			console.log(e)
								// 		}, (e) => {
								// 			console.log(e)
								// 		})
								// 	}
								// 	this.dialogVisible = false
								// 	this.dialogOptions = false
								// 	this.cards = ''
								// 	this.search()
								// }).catch(err => {
								// 	this.dialogVisible = false
								// 	this.dialogOptions = false
								// 	this.search()
								// });
							});
						}).catch(() => {

						});

						break;
					case 'add_time':
						this.input_cards = input_cards
						this.renewalDialog = true
						break;
					case 'search':
						this.input_cards = input_cards
						this.form.card= ""
						this.form.card_state= "all"
						this.form.card_type= ""
						this.form.agent_id= ''
						this.form.software = ''
						this.dialogOptions = false
						this.dialogVisible = false
						this.getData()
						break;
					default:
						break;
				}
			},
			copyValue() {
				let content = this.not_exist_cards.join('\n')
				this.$copyText(content).then((e) => {
					this.$message.success('复制成功')
				}, (e) => {
					console.log(e)
				})
			},
			toAddTime() {
				if (this.renewal === 0 && this.renewal_day==0) {
					return this.$message.error('请'+(this.renewal_way==='input'?'输入':'选择')+'续期时长')
				}
				if (this.input_cards) {
					this.addTime(this.input_cards)
				} else {
					let cards = this.multipleSelection.map(item => item.card)
					this.addTime(cards)
				}


			},
			addTime(input_cards) {
				let days = 0
				if(this.renewal_way === 'input'){
					days = this.renewal_type == 'add' ? this.renewal_day : (0 - this.renewal_day)
				}else{
					days =this.renewal_type == 'add' ? (this.renewal / 86400).toFixed(2) : (0 - (this.renewal /86400).toFixed(2))
				}
				this.$H.post('verify_center/v1_0_1.Card/Option', {
					option: 'input_cards_time_add',
					days,
					cards: input_cards
				}).then(res => {
					this.renewalDialog = false
					if (!res.data) return;
					console.log(res.data)
					this.getData(null)
					this.not_exist_cards = res.data.not_exist_cards
					this.copyCodeTitle = '成功【' + res.data.num + '】个，失败【' + (res.data.count - res.data
						.num) + '】个'
					this.dialogCopyCode = true

				});
			},
			confromCard() {
				this.dialogOptions = true
			},
			toEdit(card) {
				this.$emit('toEdit', card)

			},
			deleteAll() {
				let ids = this.multipleSelection.map(item => item.id)
				this.$confirm('是否删除选中卡密?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Card/Option', {
						option: 'delete',
						cards_id: ids
					}).then(res => {
						if (!res.data) return;
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					});

				}).catch(() => {

				});
			},
			toDelete(item) {
				this.$confirm('是否删除该卡密?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Card/Option', {
						option: 'delete',
						cards_id: [item.id]
					}).then(res => {
						if (!res.data) return;
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
					});

				}).catch(() => {

				});
			},
			is_online(card_info, software_info, now_timestamp) {
				let heart_beat_time = 30;
				if (software_info[card_info.software] != undefined) heart_beat_time = software_info[card_info.software]
					.heart_beat_time;
				if (now_timestamp - card_info.usetime < heart_beat_time && card_info.usetime > 0) return '在线';
				return '离线';
			},
			card_state_trans(card_info, now_timestamp) {
				if (card_info.status > 1) return '冻结';
				if (card_info.usetime == 0) return '未激活';
				if (card_info.endtime < now_timestamp && card_info.type != 9) return '到期';
				return '正常';
			},
			search() {
				this.form.page = 1
				this.input_cards = ''
				this.form.card_list = ''
				this.getData()
			},
			getData() {
				
				if(this.form.software==''&& (this.form.card_state=='online'||this.form.card_state=='downline')){
					this.form.card_state = ''
				}
				if(this.input_cards !==''){
					this.form.card_list = this.input_cards
				}
				console.log(this.form)
				window.localStorage.setItem('searchForm_' + this.user.center_id, JSON.stringify(this.form))
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.Card/List', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.type_config = res.data.type_config

							this.software_info = {
								...res.data.software_info
							}
							this.card_state_conf = res.data.card_state_conf
							this.total = res.data.list.total
						}

						this.list = res.data.list.data

					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			}
		}
	}
</script>

<style>
	.eloption .el-select-dropdown__wrap {
	    max-height: 100% ;
	}
	.el-button--info {
		color: #444;
		background-color: #e6e6e6;
	}

	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #F8F8F8;
		color: #333;
	}

	.el-dialog__header .el-dialog__title {
		color: #333;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #333;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>